import axios from './axios'
import Business from 'Models/Business'
import { filter, includes } from 'lodash'
import BaseDataService from 'DataServices/BaseDataService'
import defer from 'Utils/defer'

export function baseIndexUrlString () {
  return `/businesses`
}

class Businesses extends BaseDataService {
  async getAll (params) {
    return axios.get(baseIndexUrlString(), { params: params })
      .then(response => response.data)
      .then(respData => {
        return Promise.all(respData.data.map(async business => {
          return newBusiness(business)
        }))
          .then(businessesArray => {
            return { data: businessesArray, links: respData.links }
          })
      })
      .catch(console.error)
  }

  async getById (id) {
    const deferred = defer()

    if (!id) {
      console.error('Argument Missing: id is required')
    }

    const callback = (records, ids) => {
      // console.log('CALLBACK', records, ids)
      if (ids) {
        deferred.resolve(filter(records, r => includes(ids, r.id)))
      } else {
        deferred.reject([])
      }
    }

    this._createOrAddRequestToBatch(this._createDataRequest([id], callback))

    return deferred.promise
  }
}

function newBusiness (business) {
  return new Business(business)
}

export default new Businesses()
